import { Pipe, PipeTransform } from '@angular/core';
import { ConsolidationMappingFieldType } from 'src/app/shared/models/autogenerated-piping';
import { getMappingFieldTypeLabel } from '../consolidation-mapping-dictionary.model';

@Pipe({
    name: 'consolidationMappingFieldType',
    standalone: false
})
export class ConsolidationMappingFieldTypePipe implements PipeTransform {
  transform(value: ConsolidationMappingFieldType): string {
    return getMappingFieldTypeLabel(value);
  }
}
